import React from 'react';
import { useState, useRef, useEffect } from 'react';
import Stack from '@mui/material/Stack';
import { ReactSession } from 'react-client-session';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { LocalizationContext } from '../App';
import { useMediaQuery } from 'react-responsive';
import { Divider } from '@mui/material';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { CardActionArea, CardActions } from '@mui/material';


import axios from 'axios';

import { MapContainer, TileLayer, Marker, Popup, Circle } from 'react-leaflet';

import Chip from '@mui/material/Chip';
import LoupeActivityList from './LoupeActivityList';

import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import Popper from '@mui/material/Popper';
import { tsThisType } from '@babel/types';

import Link from '@mui/material/Link';
import Skeleton from '@mui/material/Skeleton';


import FilterAltIcon from '@mui/icons-material/FilterAlt';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import TranslateIcon from '@mui/icons-material/Translate';

import LinearProgress from '@mui/material/LinearProgress';
import CircularProgress from '@mui/material/CircularProgress';


import { amber, deepOrange, grey } from '@mui/material/colors';
import Backdrop from '@mui/material/Backdrop';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import LoupeDialogComponent from './LoupeDialogComponent';

import { Button as RoundedButton } from 'grommet';


const LoupeLocalActivities = (props) => {

    
    ReactSession.setStoreType("localStorage");
    const userId = ReactSession.get("userid");
    
    const allowWatch = ReactSession.get("location_watch") == "true" ? true : false


    const mapRef = useRef();
    const gridRef = useRef();

    const template = () => null;
    
    const [ mapPosition, setMapPosition ] = useState(""); 
    const [ mapCenter, setMapCenter ] = useState([0,0]);
    const [ mapZoon, setMapZoom ] = useState(2);
    const [ locationAccuracy, setLocationAccuracy ] = useState(100);
    const [ markerPosition, setMarkerPosition ] = useState(template);  
    
    const [ localActivities, setLocalActivities ] = useState(0);

    const language = props.language;
    const availableLanguages = props.availableLanguages;

    const isMobileView = useMediaQuery({
        query: '(max-width: 900px)'
    })
      

    
    const locationFound = (position, callbackHandler ) => {

        if( callbackHandler !== null && callbackHandler !== undefined ) {
            callbackHandler();
        }         

        setMapPosition(position);
        setMapCenter([position.coords.latitude, position.coords.longitude]);
        setMarkerPosition([position.coords.latitude, position.coords.longitude]);
        
        var accVal = (position.coords.accuracy < 100) ? 100 : position.coords.accuracy; 
        setLocationAccuracy(accVal);

        mapRef.current.setView( [position.coords.latitude, position.coords.longitude] , 13);
        mapRef.current.attributionControl.setPosition('topright');
        
    }
    

    const [state, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);

    // by default, we want to enable the currently chosen user locale.
    // however, if this locale is not equal to english, also add english just in case.
    // however, we also want to persist this selection, as otherwise we always have to re-enable languages. 
    // thus, check if selection is persisted? if not, use defaults.

    var initialLanguageSelection = [];
    if( ReactSession.get("selectedActivityLanguages") === undefined ) {
        initialLanguageSelection.push(props.language);
        if( props.language != 'en') initialLanguageSelection.push('en');
    } else {
        initialLanguageSelection = ReactSession.get("selectedActivityLanguages").split(',');
    } 

    



    const [ showLanguageSelection, setShowLanguageSelection ] = React.useState(false);
    const [ selectedLanguages, setSelectedLanguages ] = React.useState( initialLanguageSelection );
    const [ temporaryLanguageSelection, setTemporaryLanguageSelection ] = React.useState([]);
    const [ showSpinner, setShowSpinner ] = React.useState(false);    

    const instantListUpdate = true;

    const isInResultset = (value) => {
        if( instantListUpdate == true ) {
            return selectedLanguages.includes(value);
        } else {
            return temporaryLanguageSelection.includes(value);
        }
    }

    const handleChipClick = (value, item) => {     
        
        var targetArray = null;
        if( instantListUpdate == true ) {
            targetArray = selectedLanguages;
        } else {
            targetArray = temporaryLanguageSelection;
        }
        
        if(isInResultset(value)) {
            var idx = targetArray.indexOf(value);
            targetArray.splice(idx, 1);
        } else {
            targetArray.push(value);
        }
        forceUpdate();        
        
        if( instantListUpdate == true ){ 
            /* retrieve activities, additionally persist selected languages */
            ReactSession.set("selectedActivityLanguages", selectedLanguages.toString());
            retrieveActivities();
        }
    }

    const updateActivityList = (receivedData, listOfLanguages) => {
        var tmpArray = new Array();   
        for(var l = 0; l < receivedData.length; l++)
        {
            var d = receivedData[l];
            if( Array.isArray(d.data)) {
                d.data.map(a => { 
                    a.activityLanguage = listOfLanguages[l];
                    tmpArray.push(a); 
                });
            }

        }

        setShowSpinner(false);
        setLocalActivities(tmpArray);
    }

    const handleSelectionOpen = () => {
        setTemporaryLanguageSelection(selectedLanguages);
        setShowLanguageSelection(true);
    }

    const handleSelectionClose = () => {
        
        setShowLanguageSelection(false);
        if( instantListUpdate == false ) {            
            setLocalActivities(0);
            setSelectedLanguages(temporaryLanguageSelection);

            /* persist selected languages at this point */            
            ReactSession.set("selectedActivityLanguages", selectedLanguages.toString());
            retrieveActivities();
        } 
    }
    

    const retrieveActivities = () => {

        if( userId == "" || userId == undefined || userId == null ) return;

        setShowSpinner(true);

        let position = mapPosition; 
        if( position == "" ) return;
        
        var uriEndpoints = [];
        var usedLanguages = selectedLanguages;
        
        usedLanguages.map( lang => {

            let language = lang;
            if( language == "" ) return;
            
            // make request uri
            let uri = process.env.REACT_APP_SERVICE_URI + '/api/getActivityByLocation/' + language + '/' + position.coords.latitude + '/' + position.coords.longitude; 
            uriEndpoints.push(uri);
        });        

        axios.all(uriEndpoints.map((endpoint) => axios.get(endpoint, {
            withCredentials: true,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                'LOUPE-USR-KEY' : userId,
                'LOUPE-API-KEY' : 'APIKEY2',
            }

        }))).then(            
            (data) => updateActivityList(data, usedLanguages),
        );
    }

    const [ locationError, setLocationError ] = React.useState(false);
    const [ isWatching, setIsWatching ] = React.useState(false);

    const errorOnLocation = (callbackHandler) => {
        setLocationError(true);

        if( callbackHandler !== null && callbackHandler !== undefined ) {
            callbackHandler();
        } 
    }


    var watchId = -1;
    useEffect(() => {
        return () => {            
            if( watchId != -1) {
                navigator.geolocation.clearWatch(watchId);
            }
        }
    }, []);


    useEffect(() => {
        retrieveActivities();    
    }, [ mapPosition ]);

    const locateUserWatch = (callbackHandler) => {
        
        if ("geolocation" in navigator) { 

            const options = {
                enableHighAccuracy: true,
                maximumAge: 30000,
            };

            watchId = navigator.geolocation.watchPosition(
                (position) => locationFound(position, callbackHandler),
                () => errorOnLocation(callbackHandler),
                options          
            );    
            
            setIsWatching(true);

        } else {
            console.log("Not Available");        
        }
    }

    const locateUserStatic = (callbackHandler) => {
    
        if ("geolocation" in navigator) { 

            const options = {
                enableHighAccuracy: true,
                maximumAge: 30000,
            };

            navigator.geolocation.getCurrentPosition(
                (position) => locationFound(position, callbackHandler),
                () => errorOnLocation(callbackHandler),
                options          
            );

        } else {
            console.log("Not Available");        
        }
    }

    const locateUser = (callbackHandler) => {
        
        if( watchId != -1) {
            navigator.geolocation.clearWatch(watchId);
            watchId = -1;
            setIsWatching(false);
        }

        setLocalActivities(0);
        setMapPosition("");

        if( allowWatch ) {
            locateUserWatch(callbackHandler);
        } else {
            locateUserStatic(callbackHandler);
        }
        
    }

    const onRefresh = (resolve, reject) => {
        locateUser(resolve)
    }

    const mapReady = () => {
        locateUser(null);
    }

    const round = (value, precision) => {
        var multiplier = Math.pow(10, precision || 0);
        return Math.round(value * multiplier) / multiplier;
    }
 
    const fillOptions = { color : "#e3165b" }
    const fillOptions2 = { color : "red" }

    

    return (

        <LocalizationContext.Consumer>

            { ({strings}) => <>

                <Grid container>
                    
                    <Grid item xs={12} md={6} ref={gridRef}>

                        <MapContainer                             
                            whenCreated={mapInstance => {mapRef.current = mapInstance}}                         
                            whenReady={() => mapReady()}
                            className='mdcMap'
                            center={mapCenter} 
                            zoom={mapZoon} 
                            dragging={true}
                            touchZoom={true}                                
                            scrollWheelZoom={false}>
                        
                            <TileLayer
                                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' />

                            <>
                            { markerPosition && 
                                <>
                                    <Circle center={markerPosition} radius={locationAccuracy} pathOptions={fillOptions}/>
                                </>
                            } 
                            </>
                        </MapContainer>

                        { (isWatching) &&
                            <Alert severity="info" className={ isMobileView == true ? "text-start mb-2" : "text-start padleft mb-2"}>{strings.getString("messages.location.watch")}</Alert>                                
                        }  

                                          

                    </Grid>

                    <Grid item xs={12} md={6}>                                
                        <div className={ isMobileView == true ? 'padtop padleft padright' : 'padleft padright'}>
                           
                            { (mapPosition == "" && !locationError ) &&
                                <Alert onClose={() => {}} severity="warning" className="text-start">{strings.getString("messages.location.get")}</Alert>                                
                            } 
                            { ( locationError ) &&
                                <>
                                    <LoupeDialogComponent localePath="errors.noLocation" show={true} />
                                    <Alert onClose={() => {}} severity="error" className="text-start mb-5">{strings.getString("errors.noLocation.message")}</Alert>                                
                                </>
                            }                                                           

                            { Array.isArray(localActivities) ?  (            
                            
                                <>
                                    <div className="padleft padright">
                                        
                                        <p className="mb-4" />
                                        
                                        <Stack direction={ 'row' } justifyContent="center" className="mb-6">                                                    
                                            <RoundedButton
                                                style={{marginRight : '10px'}}
                                                color="#e3165b" 
                                                onClick={handleSelectionOpen} label={
                                                    <>
                                                        <Stack direction="row">
                                                            <TranslateIcon className="padright" color="primary"/>
                                                            <Typography color="primary" variant="body2">
                                                                {strings.getString("controls.buttons.activity.language.selection")}
                                                            </Typography>                                                                                                                                
                                                        </Stack>                                                                                                                        
                                                    </>
                                                }>
                                            </RoundedButton> 
                                            
                                            <RoundedButton
                                                color="#e3165b" 
                                                onClick={() => locateUser(null)} label={
                                                    <>
                                                        <Stack direction="row">
                                                            <GpsFixedIcon color="primary"/>                                                                                                                                                                                                   
                                                        </Stack>                                                                                                                        
                                                    </>
                                                }>
                                            </RoundedButton>
                                        </Stack>


                                    </div>

                                    <Typography variant='subtitle2'>{strings.getString("texts.activity.available")}</Typography>
                                    <LoupeActivityList className="mb-8" language={language} data={localActivities} position={mapPosition}/>                                       
                                
                                </>

                            ) : (
                                <>
                                { ( mapPosition == "" && !locationError ) &&
                                    <>
                                        <LinearProgress />
                                        <Skeleton className="mb-5" variant="rectangular" animation="wave" height={230}/>
                                    </>
                                }
                                </>
                            )}       
                        </div>                         
                    </Grid>                        

                </Grid>

                { instantListUpdate == false &&
                    <Backdrop open={showLanguageSelection} sx={{color : '#000'}} />
                }
                <Dialog
                    open={showLanguageSelection}                      
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    
                    <DialogTitle id="alert-dialog-title">
                        {strings.getString("dialogs.language.activity.local.title")}
                    </DialogTitle>
                    
                    <DialogContent>
                        {/* <DialogContentText id="alert-dialog-description"> */}
                        { availableLanguages.map(lang => {
                                                            
                            return(
                                <Chip 
                                    style={{margin : '3px'}}
                                    onClick={(e) => handleChipClick(lang.key, e)}
                                    value={lang.key} 
                                    {...( isInResultset(lang.key) ? { color : 'primary'} : {})}
                                    variant='filled'
                                    key={lang.key} 
                                    label={lang.name}/>
                            )
                        }) }
                        {/* </DialogContentText>                   */}
                    </DialogContent>

                    <DialogActions>
                        { instantListUpdate == false &&
                            <Button onClick={() => setShowLanguageSelection(false)}>{strings.getString("controls.buttons.cancel")}</Button>
                        }
                        <Button onClick={handleSelectionClose} autoFocus>OK</Button>
                    </DialogActions>

                </Dialog>                

            </>}


        </LocalizationContext.Consumer>
               
    );
    
}
export default LoupeLocalActivities;

